import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IonicModule } from 'ionic-angular';
import { LazyLoadImageModule } from "ng-lazyload-image";
import { LazyImgComponentModule } from '../lazy-img/lazy-img.module';
import { ImageComponent } from './image-component';

@NgModule({
  declarations: [
    ImageComponent,
  ],
  imports: [
    IonicModule,
    LazyLoadImageModule,
    FlexLayoutModule,
    LazyImgComponentModule,
  ],
  exports: [
    ImageComponent
  ]
})
export class ImageComponentModule {}



// WEBPACK FOOTER //
// ./src/components/image-component/image-component.module.ts